interface ProjectIconProps {
  icon: string | null | undefined;
  className?: string;
}

export function ProjectIcon({ icon, className = "" }: ProjectIconProps) {
  if (!icon) return null;

  // Check if it's an emoji (short string without URL pattern) or a URL
  const isUrl = icon.startsWith("http://") || icon.startsWith("https://");

  if (isUrl) {
    return <img src={icon} alt="" className={`inline-block w-4 h-4 ${className}`} loading="lazy" />;
  }

  // It's an emoji
  return <span className={className}>{icon}</span>;
}
